import { render, staticRenderFns } from "./CommunityGovernance.vue?vue&type=template&id=0c774b1c&scoped=true"
import script from "./CommunityGovernance.vue?vue&type=script&lang=js"
export * from "./CommunityGovernance.vue?vue&type=script&lang=js"
import style0 from "./CommunityGovernance.vue?vue&type=style&index=0&id=0c774b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c774b1c",
  null
  
)

export default component.exports